import { Box, Card, TextField, InputAdornment, Button, TableContainer, Table, TableBody, TableRow, TableCell, Checkbox, IconButton, Popover, MenuItem, Typography, Avatar, TablePagination, FormControl, InputLabel, Select, Grid, TableHead, Divider, LinearProgress } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import Details from "./Detail";
import { useTranslation } from "react-i18next";
import { numberFormat, numberFormatWithK } from "../../utils/nunberFormat";
import TableSearchNotFound from "../../components/tableSearchNotFound";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import Pagination from '@mui/material/Pagination';
import { SELECT_BACKGROUND_COLOR, TABLE_HEADER_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors";
import EXPORT_FILE from '../../assets/images/export_file.svg';
import InfoIcon from '@mui/icons-material/Info';
import useReportController from "./controller";
import { OrderModel } from "../../models/order";
import { calculateOrderProductUnitByCarts } from "../../utils/calculateOrderProductUnitByCarts";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { convertOrderStatusCodeToOrderStatusEnum } from "../../utils/convertOrderStatusValue";
import { convertDateStringToNormalDateTime, convertDateStringToNormalString } from "../../utils/convertDateFormat";
import StatusOrderReportComponent from "./components/orderReportStatus";
import StatusPaymentReportComponents from "./components/paymentReportStatus";
import StatusDriverReportComponents from "./components/driverReportStatus";
import TabPanelReport from "./components/tabPanel";
import { OrderStatusEnum } from "../../enums/orderStatus";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { ReportEnum } from "../../enums/reportEnum";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import ButtonExportCsv from "../../components/ButtonExportCsv";
import { CSV_ORDER_HEADER } from "./csvHeaders/order";
import { findOrderCreateTime } from "../../utils/findOrderCreareTime";
import TabShowOrderComponent from "./components/tabShowOrder";
import ACTIVE_PRODUCT_STATISTIC from '../../assets/images/active_product_static.svg';
import INACTIVE_PRODUCT_STATISTIC from '../../assets/images/inactive_product_statistic.svg';
import ALL_PRODUCT_STATISTIC from '../../assets/images/all_product_statistic.svg';
import PRODUCT_NEED_TO_APPROVE_STATISTIC from '../../assets/images/product_need_to_approve.svg';
import { MerChantModel } from "../../models/merChantModel";
import StatusChip from "./components/statusChip";
import ShipmentMethodRiderDetail from "./components/statusRiderAssistant";
import ShipmentMethodChip from "./components/statusOrder";
import { ShipmentMethodEnum } from "../../enums/shipmentMethod";

const SalesReportView = () => {
    const { t, i18n } = useTranslation("global");

    const controller = useReportController()

    const tableHeaders: string[] = ["No.", "Customer name", "Order ID", "Order number", "Item unit", "Shipment method", "Payment method", "Phone", "Price", ""];
    return <Box>
        {
            !controller.openForm
                ?
                <>

                    <Box sx={{ display: controller.loadingData ? "flex" : "none", justifyContent: 'center', alignItems: 'center', }}>
                        <LoadingAnimatedIcon />
                    </Box>
                    <Box sx={{ display: controller.loadingData ? "none" : "block" }}>
                        <Box mb={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography color={TEXT_TITLE_COLOR} fontWeight="bold"><span style={{ fontSize: 30 }}>{t("allReport_page.Sale Report")}</span> </Typography>

                                <TextField inputRef={controller.orderId} fullWidth sx={{ maxWidth: 250 }} placeholder={`${t("allReport_page.Search by Order ID")}...`}
                                    onKeyDown={(e: any) => {
                                        if (e.key === "Enter") {
                                            controller.handleFetchDataByOrderId()
                                        }
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" >
                                                <IconButton onClick={controller.handleFetchDataByOrderId}>
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }} size="small" />
                                <TextField type="date" fullWidth
                                    inputRef={controller.startDateRef}
                                    sx={{
                                        maxWidth: 150, "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                                border: "none"
                                            }
                                        }
                                    }} size="small" label={t("allReport_page.Start Date")} InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            backgroundColor: SELECT_BACKGROUND_COLOR,
                                            borderRadius: '8px'
                                        }
                                    }} InputLabelProps={{ shrink: true }} />
                                <TextField type="date" fullWidth
                                    inputRef={controller.endDateRef}
                                    sx={{
                                        maxWidth: 150, "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                                border: "none"
                                            }
                                        }
                                    }} size="small" label={t("allReport_page.End Date")} InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            backgroundColor: SELECT_BACKGROUND_COLOR,
                                            borderRadius: '8px'
                                        }
                                    }} InputLabelProps={{ shrink: true }} />
                                <FormControl fullWidth sx={{ maxWidth: 150, }}>
                                    <InputLabel id="status-label-id">{t("allReport_page.Status")}</InputLabel>
                                    <Select
                                        labelId="status-label-id"
                                        id="status-id"
                                        value={controller.orderStatusValue}
                                        onChange={controller.handleSelectedOrderStatus}
                                        label="Status"
                                        size="small"
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                    >
                                        <MenuItem value={OrderStatusEnum.All}>
                                            {t("All")}
                                        </MenuItem>
                                        <MenuItem value={OrderStatusEnum.Delivered}>
                                            {t("allReport_page.Delivered")}
                                        </MenuItem>
                                        <MenuItem value={OrderStatusEnum.Return}>
                                            {t("allReport_page.Returned")}
                                        </MenuItem>
                                        <MenuItem value={OrderStatusEnum.Failed}>
                                            {t("allReport_page.Failed")}
                                        </MenuItem>
                                        <MenuItem value={OrderStatusEnum.Partially}>
                                            {t("allReport_page.Partially completed")}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth sx={{ maxWidth: 148 }}>
                                    <InputLabel id="all-branch-label-id">{t("allReport_page.All Branch")}</InputLabel>
                                    <Select
                                        labelId="all-branch-label-id"
                                        id="all-branch-id"
                                        value={controller.merchantValue}
                                        onChange={(e) => controller.handleSelectedMerchant(e.target.value)}
                                        label="All branch"
                                        size="small"
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                    >
                                        <MenuItem value="All">{t("All")}</MenuItem>
                                        {
                                            controller.merchantData?.map((item: MerChantModel) => <MenuItem key={item?.id} value={item?.id}><span style={{ color: TEXT_TITLE_COLOR }}>{item?.company} : </span> {i18n.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                                <Button onClick={controller.handleFilterData} variant="contained" sx={{ textTransform: 'none' }}>{t("allReport_page.Search")}</Button>
                            </Box>
                            {/* <Box>
                                <img src={EXPORT_FILE} alt="" style={{ width: 20, height: 28, cursor: 'pointer' }} />
                            </Box> */}

                        </Box>
                        <Box mb={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#C8FACD', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#005249" sx={{ mb: 1 }}>{t("All")}</Typography>
                                            <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormatWithK(controller.dataReportStatistic.all)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={ACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>  {t("allReport_page.Delivered")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormatWithK(controller.dataReportStatistic?.delivered)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={ALL_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#FFF5CC', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>{t("allReport_page.Partially completed")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormatWithK(controller.dataReportStatistic?.partiallyCompletedSale)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={PRODUCT_NEED_TO_APPROVE_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ background: 'rgba(145, 158, 171, 0.32)', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>{t("allReport_page.Returned")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormatWithK(controller.dataReportStatistic?.returnSale)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={INACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#FFB1BB', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>{t("allReport_page.Cancelled")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormatWithK(controller.dataReportStatistic?.failedSale)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={INACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Box>
                        <Box sx={{ mt: 1, mb: 1, display: 'flex', justifyContent: 'end' }}>
                            <ButtonExportCsv loading={false} onClick={() => {
                                if (controller.buttonExportCsv.current) {
                                    controller.buttonExportCsv.current.link.click();
                                }
                            }} buttonRef={controller.buttonExportCsv} title="Export CSV" data={controller.findDataExportCsv()} filename="order_report.csv" headers={CSV_ORDER_HEADER} />
                        </Box>
                        <Box mb={2}>
                            <TabShowOrderComponent value={controller.showInMoney} onChange={(newValue: string) => controller.setShowInMoney(newValue)} />
                        </Box>
                        {/* <Box mb={1}>
                            <TabPanelReport value={controller.reportType} onChange={controller.setReportType} />
                        </Box> */}
                        <Box >
                            <Box>
                                <TableContainer >
                                    <Table>
                                        <TableHead sx={{ background: TABLE_HEADER_BACKGROUND_COLOR }}>
                                            <TableRow>
                                                <TableCell>{t("allReport_page.No")}</TableCell>
                                                <TableCell>{t("allReport_page.Order number")}</TableCell>
                                                <TableCell>{t("allReport_page.Order ID")}</TableCell>
                                                <TableCell>{t("allReport_page.Shipment method")}</TableCell>
                                                <TableCell>{t("allReport_page.Item unit")}</TableCell>
                                                <TableCell>{t("allReport_page.Payment method")}</TableCell>
                                                <TableCell>{t("allReport_page.Order status")}</TableCell>
                                                <TableCell>{t("allReport_page.Edit Order")}</TableCell>
                                                <TableCell>{t("allReport_page.Date")}</TableCell>
                                                <TableCell>{t("allReport_page.last update")}</TableCell>
                                                <TableCell>{t("allReport_page.Amount")}</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                controller.rows?.map((row: OrderModel, index: number) => {

                                                    return (
                                                        <TableRow hover key={row?.id} tabIndex={-1}>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{t("allReport_page.Order number")} : {row?.orderNumber}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNo}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                {
                                                                    row.riderAssist === true ? <ShipmentMethodRiderDetail value={row.riderDetail} /> : <ShipmentMethodChip value={row?.orderMethod as ShipmentMethodEnum} />
                                                                }
                                                            </TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{calculateOrderProductUnitByCarts(row?.carts)}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.paymentMethod}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}><StatusChip status={convertOrderStatusCodeToOrderStatusEnum(row?.status?.code)} /></TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none', color: row?.updateByAdmin ? "red" : "green" }}>{row?.updateByAdmin ? "ມີການແກ້ໄຂອໍເດີ" : "ຈັດສົ່ງສຳເລັດ"}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{findOrderCreateTime(row)}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{convertDateStringToNormalDateTime(row?.orderStatusTime?.dateTime?.at(-1)?.time ?? "")}</TableCell>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat(row?.totoalWithDeliveryFee)} kip</TableCell>
                                                            <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}>
                                                                    <MoreHorizIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                        </TableBody>
                                        {controller.isSearchNotFound && (
                                            <TableSearchNotFound searchValue={controller.searchValue} colSpan={tableHeaders.length + 1} />
                                        )}
                                    </Table>
                                </TableContainer>
                                <Divider />
                                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 1 }}>
                                    <Pagination onChange={controller.handleChangePage} page={controller.currentPage} count={controller.countPagination} color="primary" />
                                </Box>

                            </Box>
                        </Box>
                        <Popover
                            open={Boolean(controller.openMenu)}
                            anchorEl={controller.openMenu}
                            onClose={controller.handleCloseMenu}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 140,
                                    '& .MuiMenuItem-root': {
                                        px: 1,
                                        typography: 'body2',
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem onClick={() => {
                                controller.handleOpenForm();
                            }}>
                                <InfoIcon />
                                &nbsp;&nbsp;
                                {t("allReport_page.View detail")}

                            </MenuItem>
                        </Popover>
                    </Box>

                </>
                :
                <Details onClose={controller.handleCloseForm} selectedData={controller.selectedReportData} />
        }
    </Box >

}
export default SalesReportView;